import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TypesService {

    constructor(private http: HttpClient) { }

    getRenovationTypes() {
        const url = `${env.LgvApiBaseUrl}/types/avm-adjustment-reasons`;
        return this.http.get<any>(url);
    }
}
